const NORMALIZED_ID = ':id';
const SCENARIO_ID = ':scenario_id';
const ID_WHITELIST = new Set();

export function normalizePath(input: string): string {
  try {
    const url = new URL(input);
    const segments = url.pathname.split('/').filter(Boolean);

    const normalized: string[] = [];

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];

      if (segments[i - 1] === 'i') {
        normalized.push(SCENARIO_ID);
        continue;
      }

      const prev = segments[i - 1];

      const isUuid =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(segment);
      const isOtherId = /^[0-9a-f]{6,}$/.test(segment) || /^\d+$/.test(segment);
      const isId = isUuid || isOtherId;
      const isWhitelisted = ID_WHITELIST.has(prev ?? '');

      if (isId && !isWhitelisted) {
        normalized.push(NORMALIZED_ID);
      } else {
        normalized.push(segment);
      }
    }

    return '/' + normalized.join('/');
  } catch (error) {
    console.error('Cannot normalize path:', error);
    return input;
  }
}
